/**
 * Shared conference messaging safety helpers for Click&Pledge.
 */

import logger from '../app/logger';

/**
 * Determines if conference messaging can be safely attempted.
 *
 * @param {Object} conference - Conference instance.
 * @returns {boolean}
 */
export function canSendConferenceMessage(conference) {
    if (!conference || typeof conference.sendMessage !== 'function') {
        return false;
    }

    if (typeof conference.isJoined === 'function') {
        try {
            return conference.isJoined();
        } catch (error) {
            logger.warn('clickandpledge-givent: conference.isJoined() failed', error);

            return false;
        }
    }

    return true;
}

/**
 * Sends a conference message only when the conference is connected/joined.
 * Prevents runtime errors when XMPP is disconnected.
 *
 * @param {Object} conference - Conference instance.
 * @param {Object} message - Payload to broadcast.
 * @param {string} context - Logging context label.
 * @returns {boolean}
 */
export function safeConferenceSendMessage(conference, message, context = 'clickandpledge-givent') {
    if (!canSendConferenceMessage(conference)) {
        logger.warn(`${context}: skipped conference.sendMessage because conference is not connected/joined`);

        return false;
    }

    try {
        conference.sendMessage(message);

        return true;
    } catch (error) {
        logger.warn(`${context}: conference.sendMessage failed`, error);

        return false;
    }
}
